import type { DocumentStatus } from '@tcrd/shared';

export interface DocumentType {
  id: string;
  code: string;
  name: string;
  subject: 'DRIVER' | 'VEHICLE';
  requiresExpiry: boolean;
  mandatory: boolean;
}

export interface DocumentDto {
  id: string;
  type: DocumentType;
  driver: { id: string; name: string };
  vehicle: { id: string; label: string } | null;
  number: string | null;
  category: string | null;
  issuer: string | null;
  issuedAt: string | null;
  startsAt: string | null;
  expiresAt: string | null;
  daysLeft: number | null;
  status: DocumentStatus;
  verifiedAt: string | null;
  rejectionReason: string | null;
  superseded: boolean;
  files: Array<'FRONT' | 'BACK' | 'ATTACHMENT'>;
  verifications?: Array<{ id: string; decision: 'VERIFIED' | 'REJECTED'; reason: string | null; createdAt: string }>;
}

export interface Compliance {
  ok: boolean;
  expired: Array<{ documentType: string; vehicle: string | null; status: string }>;
  warnings: Array<{ documentType: string; vehicle: string | null; status: string }>;
  /** Obligatorios no vigentes y verificados. */
  notReady?: Array<{ documentType: string; vehicle: string | null; status: string }>;
  /** Si la regla de documentos verificados aplica a este conductor (socios). */
  required?: boolean;
  hasVehicle?: boolean;
}

export function daysLeftLabel(d: number | null): string | null {
  if (d === null) return null;
  if (d < 0) return `Venció hace ${-d} día${d === -1 ? '' : 's'}`;
  if (d === 0) return 'Vence hoy';
  return `Vence en ${d} día${d === 1 ? '' : 's'}`;
}

export const SIDE_LABEL = { FRONT: 'Frente', BACK: 'Reverso', ATTACHMENT: 'Documento adjunto' } as const;
